﻿const axios = require('axios');
import FileUpload from './components/FileUpload.vue';
import { required, requiredIf, email, numeric, minLength, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

const contactCreateApp = {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        FileUpload
    },
    data() {
        return {
            apiCase: '',
            apiDossier: '',
            loading: false,
            ContactChoice: '',
            checkChoice: false,
            Dossiernummer: '',
            dossierError: false,
            redirectDossier: '',
            form: {
                Email: '',
                Telefoonnummer: '',
                Onderwerp: '',
                Beschrijving: '',
                FileIDs: []
            },
            formError: false,
            caseNummer: '',
            formSend: false,
            redirectClaim: '',
            uploadFiles: [],
            user: null
        }
    },
    computed: {
        checkAccess() {
            if (this.user === null) {
                return false;
            } else {
                return this.user.organisationAllowNewClaims;
            }
        },
    },
    validations() {
        return {
            ContactChoice: { required },
            Dossiernummer: { required: requiredIf(() => this.ContactChoice === 'Vraag_over_een_bestaand_dossier') },
            form: {
                Email: {
                    required: requiredIf(() => this.ContactChoice === 'Andere_vraag'),
                    email
                },
                Telefoonnummer: {
                    required: requiredIf(() => this.ContactChoice === 'Andere_vraag'),
                    numeric,
                    minLength: minLength(10),
                    maxLength: maxLength(13)
                },
                Onderwerp: { required: requiredIf(() => this.ContactChoice === 'Andere_vraag') },
                Beschrijving: { required: requiredIf(() => this.ContactChoice === 'Andere_vraag') }
            }
        }
    },
    methods: {
        async resolveAction() {
            let contactDossierNr = this.Dossiernummer;

            const validChoice = await this.v$.ContactChoice.$validate();
            if (validChoice) {
                if (this.ContactChoice === 'Vraag_over_een_bestaand_dossier') {
                    const validDossier = await this.v$.Dossiernummer.$validate();

                    if (!contactDossierNr.endsWith('000')) {
                        contactDossierNr += '000';
                    }

                    if (validDossier) {
                        let apiDossier = this.apiDossier.replace('{dossierid}', contactDossierNr);
                        const response = await axios.get(apiDossier);
                        if (response.status === 200) {
                            if (response.data) {
                                location.href = this.redirectDossier + contactDossierNr;
                            } else {
                                this.dossierError = true;
                            }
                        }
                    }
                } else if (this.ContactChoice === 'Indienen_nieuwe_incasso') {
                    location.href = this.redirectClaim;
                } else if (this.ContactChoice === 'Andere_vraag') {
                    if (this.checkChoice) {
                        if (!this.formSend) {
                            const validForm = await this.v$.form.$validate();
                            if (validForm) {
                                this.loading = true;
                                this.form.FileIDs = this.$refs.fileUploadContact.fileIDs;
                                const response = await axios.post(this.apiCase, this.form);
                                this.loading = false;
                                if (response.status === 200) {
                                    if (response.data.typeAlias === 'Success') {
                                        this.formSend = true;
                                    } else {
                                        this.formError = true;
                                    }
                                }
                            }
                        } else {
                            this.form.Telefoonnummer = '';
                            this.form.Onderwerp = '';
                            this.form.Beschrijving = '';
                            this.form.FileIDs = [];
                            this.v$.$reset();
                            this.formSend = false;
                            this.checkChoice = false;
                            this.ContactChoice = '';
                        }
                    } else {
                        this.checkChoice = true;
                    }
                }
            }
        },
        resetAction() {
            this.v$.$reset();
            this.checkChoice = false;
            this.dossierError = false;
        },
    },
    mounted() {
        if (this.$el.dataset.apicase) this.apiCase = this.$el.dataset.apicase;
        if (this.$el.dataset.apidossiercheck) this.apiDossier = this.$el.dataset.apidossiercheck;
        if (this.$el.dataset.redirectdossierurl) this.redirectDossier = this.$el.dataset.redirectdossierurl;
        if (this.$el.dataset.redirectclaimurl) this.redirectClaim = this.$el.dataset.redirectclaimurl;
        if (sessionStorage.getItem('user') !== null) {
            this.user = JSON.parse(sessionStorage.getItem('user'));
            this.form.Email = JSON.parse(sessionStorage.getItem('user')).email;
        }
    }
}

export default contactCreateApp;